import { TmrBaseResource } from 'stylewhere/api'

export class SimpleParcelList extends TmrBaseResource {
  static endpoint = 'logistics/api/v1/operations/simpleParcelList'
}
